import { HandoverV2DetailParams } from "@/data/payload/api/HandoverV2ApiRequest";

const BASE = "/hydra/v2/handover";

export class HandoverV2Endpoints {
  getDetailHandover(params: HandoverV2DetailParams) {
    return `${BASE}/stt-detail?${params.toQueryString()}`;
  }

  processHandover() {
    return BASE;
  }
}
